import { render, staticRenderFns } from "./RedesignUserinfo.vue?vue&type=template&id=ab245208&scoped=true"
import script from "./RedesignUserinfo.vue?vue&type=script&lang=js"
export * from "./RedesignUserinfo.vue?vue&type=script&lang=js"
import style0 from "./RedesignUserinfo.vue?vue&type=style&index=0&id=ab245208&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"
import style1 from "./RedesignUserinfo.vue?vue&type=style&index=1&id=ab245208&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab245208",
  null
  
)

export default component.exports